var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusId !== _vm.$constant.zz_reservation_status_2.unnecessary)?_c('span',{class:this.getBadgeType(),style:({
    'background-color': this.getBackgroundColor(),
  })},[_vm._v(_vm._s(_vm.statusLabel))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }